import { formatDateTime } from '../../../lib/datetime';
import { formatDuration } from '../../../lib/format';
import type { JobRunSummary } from '../types/jobs';
import { JobStatusBadge } from './JobStatusBadge';

interface JobRunTableProps {
  jobs: JobRunSummary[];
  selectedUuid: string | null;
  onSelect: (uuid: string) => void;
}

export function JobRunTable({ jobs, selectedUuid, onSelect }: JobRunTableProps) {
  if (jobs.length === 0) {
    return <p className="jobs-table__empty">No job runs found.</p>;
  }

  return (
    <table className="jobs-table">
      <thead>
        <tr>
          <th>Job</th>
          <th>Status</th>
          <th>Started</th>
          <th>Duration</th>
          <th>By</th>
        </tr>
      </thead>
      <tbody>
        {jobs.map((job) => (
          <tr
            key={job.uuid}
            className={`jobs-table__row${selectedUuid === job.uuid ? ' jobs-table__row--selected' : ''}`}
            onClick={() => onSelect(job.uuid)}
            role="button"
            tabIndex={0}
            aria-selected={selectedUuid === job.uuid}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') onSelect(job.uuid);
            }}
          >
            <td>
              <div className="jobs-table__name">
                <span>{job.jobName}</span>
                {job.relatedResourceName && (
                  <span className="jobs-table__resource">{job.relatedResourceName}</span>
                )}
              </div>
            </td>
            <td>
              <JobStatusBadge status={job.status} />
            </td>
            <td className="jobs-table__date">{formatDateTime(job.startedAt ?? job.createdAt)}</td>
            <td className="jobs-table__duration">{formatDuration(job.durationMs)}</td>
            <td className="jobs-table__by">
              {job.triggerType === 'manual' ? (job.triggeredByEmail ?? 'Manual') : 'Scheduled'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
